import { render, staticRenderFns } from "./MarkdownBlog.vue?vue&type=template&id=3a31a1af"
import script from "./MarkdownBlog.vue?vue&type=script&lang=js"
export * from "./MarkdownBlog.vue?vue&type=script&lang=js"
import style0 from "./MarkdownBlog.vue?vue&type=style&index=0&id=3a31a1af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports